module.exports = __webpack_public_path__ + "static/media/icon-calendar-blue.111c84e9.svg";